import apiService from '../api/ApiService';
import liveSessioner from '../livesession/LiveSessioner';
import livestreamActions from '../../actions/LivestreamActions';
import storeManager from '../../store/StoreManager';
import liveSessionService from '../livesession/LiveSessionService';
import idVerificationService from '../idverification/IdVerificationService';
import sessionReader from '../../store/readHelpers/SessionReader';
import timeActions from '../../actions/TimeActions';
import pendingResumeNavigation from '../../constants/PendingResumeNavigation';
import navigationService from '../NavigationService';

const { liveSessionMessageType } = livestreamActions;

const liveSessionMessageHandler = {
    shouldNavigateToPhotoRetake(body) {
        const { idverification, livestream } = storeManager.getState();
        const registeredCall = liveSessionService.getRegisteredCall(livestream, body.messagerId);

        return !!registeredCall
            && idVerificationService.isRequestPhotoRetakeVerificationStatus(idverification)
            && liveSessionService.isCallFinished(registeredCall, body)
            && this.isPhotoRetakeRequestedDuringTheCall(registeredCall, idverification);
    },

    isPhotoRetakeRequestedDuringTheCall(registeredCall, idverification) {
        const callProctoringModeSetTime = registeredCall.proctoringModeSetTime;
        const photoRetakenRequestSetTime = idverification.idVerificationStatusSetTime;
        return !!callProctoringModeSetTime && !!photoRetakenRequestSetTime && callProctoringModeSetTime < photoRetakenRequestSetTime;
    },

    handleOfferOrIceCandidatesMessage(body) {
        // "New" in case we haven't created an offer with this liveSessionTimestamp signature yet.
        // "Latest" in case we already have a P2P connection registered to it and this is a recovery attempt.
        if (!liveSessioner.isNewOrLatestConnectionOfferFromProctor(body.messagerId, body.liveSessionTimestamp)) {
            console.log(`Ignoring message from stale P2P connection: ${body.messageType}`, body);
            return;
        }

        if (body.messageType === liveSessionMessageType.OFFER) {
            liveSessioner.receiveOffer(
                body.messagerId,
                body.messageDescription,
                body.proctoringMode,
                body.liveSessionTimestamp,
                body.videoExpectation,
                body.audioExpectation
            );
        } else {
            liveSessioner.receiveRemoteIceCandidates(
                body.messagerId,
                body.iceCandidates,
                body.liveSessionTimestamp
            );
        }
    },

    handleNavigationToIdVerification() {
        if (sessionReader.isPaused()) {
            storeManager.dispatch(timeActions.setPendingResumeNavigation(pendingResumeNavigation.PHOTO_RETAKE));
        } else {
            idVerificationService.gotoPhotoRetake();
        }
    },

    handleProctoringModeUpdatedMessage(body) {
        // check it before state.livestream is updated
        const isNavigateToIdVerificationNeeded = this.shouldNavigateToPhotoRetake(body);

        liveSessioner.receiveProctoringMode(
            body.messagerId,
            body.proctoringMode
        );

        if (isNavigateToIdVerificationNeeded) {
            this.handleNavigationToIdVerification();
        }
    },

    handleLeftSessionMessage(body) {
        liveSessioner.receiveLeavingProctor(
            body.messagerId,
        );
    },

    handleAreYouOnlineMessage(body) {
        apiService.sendLiveSessionCandidateOnlineConfirmation(body.messagerId);
    },

    handleStudentEvictionRequested() {
        navigationService.exitTest();
    },

    handle(body) {
        if (!body) {
            return;
        }

        console.log(`${(new Date()).toISOString()}: Got message for liveSession: ${body.messageType}`, body);

        switch (body.messageType) {
        case liveSessionMessageType.OFFER:
        case liveSessionMessageType.ICE_CANDIDATES: {
            this.handleOfferOrIceCandidatesMessage(body);
            break;
        }

        case liveSessionMessageType.PROCTORING_MODE_UPDATED: {
            this.handleProctoringModeUpdatedMessage(body);
            break;
        }

        case liveSessionMessageType.LEFT_SESSION: {
            this.handleLeftSessionMessage(body);
            break;
        }

        case liveSessionMessageType.ARE_YOU_ONLINE_CANDIDATE: {
            this.handleAreYouOnlineMessage(body);
            break;
        }

        case liveSessionMessageType.TT_EVICTION_REQUESTED: {
            this.handleStudentEvictionRequested();
            break;
        }

        default:
            break;
        }
    },
};

export default liveSessionMessageHandler;
